import React from "react";
import { Menu } from "@mui/material";

interface MilestoneMenuBaseProps {
     anchorEl: HTMLElement | null;
     isOpen: boolean;
     onClose: () => void;
     children: React.ReactNode;
}

/**
 * Base menu component for milestone-related menus
 * Provides consistent positioning and behavior
 */
const MilestoneMenuBase: React.FC<MilestoneMenuBaseProps> = ({
     anchorEl,
     isOpen,
     onClose,
     children,
}) => {
     return (
          <Menu
               anchorEl={anchorEl}
               open={isOpen}
               onClose={onClose}
               anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
               transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
               {children}
          </Menu>
     );
};

export default MilestoneMenuBase; 